import React, {FC, useEffect, useState} from 'react'
import cn from 'classnames'
import {Formik, Form as FormikForm} from 'formik'
import getLocalizeString from "../../utils/getLocalizeString"
import {TForm2Auth} from "../../types"
import {useAppContext} from "../../AppContext"
import css from '../Form/Form.module.scss'

const Form2Auth: FC<TForm2Auth> = ({title, initFields, validationSchema, type, onSubmit, children}) => {
  const [formattedType, setFormattedType] = useState<string>('')
  const [text, setText] = useState<string>('')
  const {appType} = useAppContext()

  useEffect(() => {
    if ( type ) {
      switch ( type ) {
        case 'telegram':
          setFormattedType('Telegram')
          break
        case 'google':
          setFormattedType('Google Authentificator')
          break
        case 'mail':
          setFormattedType('Email')
          break
      }
    }
  }, [type])

  useEffect(() => {
    if ( formattedType ) {
      setText(() => {
        return `
        ${getLocalizeString(
          'You have activated two-factor authentication with {type}.',
          {type: `<b>${formattedType}</b>`})
        }      
        ${getLocalizeString(
          'Enter 6-digit code from {type} message to enter profile', 
          {type: `<b>${formattedType}</b>`})
        }`
      })
    }
  }, [formattedType])

  return (
    <div className={cn([css.Form, css.Form_2fa])}>
      <div className={css.Form__Image}>
        <img src={`${process.env.PUBLIC_URL}/2fa.png`} alt="2fa"/>
      </div>

      <div className={css.Form__Title}>
        <span>{getLocalizeString(title)}</span>
      </div>

      <div
        className={css.Form__Text}
        dangerouslySetInnerHTML={{__html: text}}
      />

      <Formik
        initialValues={initFields}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          onSubmit && onSubmit(values, actions)
        }}
      >
        {(props) => (
          <FormikForm
            style={{paddingBottom: (appType === 'pro') ? '48px' : '0'}}
          >
            {children(props)}
          </FormikForm>
        )}
      </Formik>
    </div>
  )
}

export default Form2Auth
